import type { Location } from '@piccolohealth/pbs-common';
import { Select, type SelectOption, type SelectProps } from '@piccolohealth/ui';
import React from 'react';
import { useOrganizationQuery } from '../../graphql/hooks/useOrganizationQuery';
import { useAppContext } from '../../hooks/useAppContext';

export interface LocationChooserProps
  extends Omit<SelectProps<string, unknown>, 'value' | 'onChange' | 'options' | 'selectedValues'> {
  value: string | null;
  onChange: (value: string | undefined) => void;
}

export const LocationChooser = (props: LocationChooserProps) => {
  const { value, onChange, ...rest } = props;
  const { organization } = useAppContext();

  const { isLoading, data } = useOrganizationQuery({
    organizationId: organization.id,
  });

  const locations = (data?.organization?.locations as Location[]) ?? [];

  const options: SelectOption<string>[] = locations.map((location) => ({
    label: location.name,
    value: location.id,
    raw: location.id,
    color: location.color,
  }));

  const onChangePrime = React.useCallback(
    (value: SelectOption<string> | null) => {
      onChange(value?.value ?? undefined);
    },
    [onChange],
  );

  const selectedValue = React.useMemo(() => {
    return options.find((option) => option.value === value) ?? null;
  }, [options, value]);

  return (
    <Select
      isLoading={isLoading}
      value={selectedValue}
      options={options}
      onChange={onChangePrime}
      {...rest}
    />
  );
};
